const carouselItems = [
  {
    title: '久久视频·深度专题',
    desc: '久久视频平台资源全景扫描，从热门分类到最新上线，为您全面解析久久视频在线视频网站的精彩内容生态与独特优势。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20art%20with%20flowing%20organic%20shapes%2C%20amber%20and%20terracotta%20tones%2C%20modern%20digital%20composition%2C%20featured%20content%20layout%2C%20no%20text%2C%20cinematic%20wide%20format%2C%20professional%20quality&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '专题推荐',
    badge: '热门',
  },
  {
    title: '芒果视频·资源导航',
    desc: '芒果视频在线视频网站完整资源导航指南，涵盖视频播放器在线看视频的多种访问方式与实用技巧。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20abstract%20design%20with%20sweeping%20curves%2C%20soft%20coral%20and%20cream%20gradient%2C%20modern%20minimal%20feature%20banner%2C%20no%20text%2C%20clean%20composition%2C%20wide%20format&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '资源导航',
    badge: '推荐',
  },
  {
    title: '97视频·每日更新',
    desc: '97视频平台每日更新动态追踪，及时获取视频播放器在线看视频最新入口信息与站点状态变化。',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20warm%20abstract%20composition%20with%20layered%20shapes%2C%20crimson%20and%20amber%20tones%2C%20digital%20media%20aesthetic%2C%20update%20theme%2C%20no%20text%2C%20wide%20format%2C%20professional&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '每日更新',
    badge: '新',
  },
  {
    title: '丝瓜视频·精选合集',
    desc: '丝瓜视频在线视频网站优质内容精选合集，为您整理视频播放器在线看视频的精选资源清单。',
    img: 'https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20pattern%20with%20gentle%20waves%2C%20peach%20and%20gold%20tones%2C%20modern%20collection%20aesthetic%2C%20no%20text%2C%20cinematic%20width%2C%20clean%20and%20elegant&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '精选合集',
    badge: '精选',
  },
  {
    title: '蓝莓视频·新站速递',
    desc: '蓝莓视频及更多在线视频网站新站点上线速递，扩展国产91视频的视频播放器在线看视频资源版图。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20warm%20abstract%20digital%20art%2C%20rich%20amber%20and%20terracotta%20gradient%2C%20new%20arrival%20theme%2C%20modern%20feature%20card%2C%20no%20text%2C%20wide%20format%2C%20professional%20quality&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '新站速递',
    badge: '速递',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          聚焦久久视频、芒果视频、97视频、丝瓜视频等在线视频网站的热点内容与资源动态
        </p>
        <div className="flex flex-nowrap gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-[320px] md:w-[380px] bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all cursor-pointer group"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-background-50/90 text-xs font-medium text-primary-600 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="inline-block px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}